import React, { useState, useRef } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import EQuoteSailingsFullSearchCabinTable from './EQuoteSailingsFullSearchCabinTable'
import { fetchGroupAvailability } from '../../../../actions/fetchGroupAvailability'
import { getPackagesDetails } from '../../../../reducers/fetchPackagesReducers'

import brandLoader from '../../../../assets/icons/brand-loader-final.gif'

const EQuoteSailingsFullSearchCabins = ({
  packageData,
  superCategory,
  superCategoryFullName,
  type,
  cabinData,
  keyIdentifier,
  closeHandler,
  currencySymbol,
  currencySymbolPlacement,
  ssoData
}) => {
  const [groupData, setGroupData] = useState(null)
  const fetchRef = useRef(false)

  const fetchGroupData = async () => {
    fetchRef.current = true

    if (!packageData.groupId) {
      setGroupData([])
      return
    }

    const res = await fetchGroupAvailability({
      groupId: packageData.groupId,
      agencyId: ssoData.agency.agency_id
    })

    setGroupData(res)
  }

  if (!fetchRef.current) {
    fetchGroupData()
  }

  if (groupData === null) {
    return (
      <div
        className="u-loading-spinner"
        style={{
          flex: 1
        }}
      >
        <img src={brandLoader} alt="loading..." />
        <div className="loading-message">Checking Availability...</div>
      </div>
    )
  }

  if (
    !_.isEmpty(packageData) &&
    !_.isEmpty(cabinData) &&
    cabinData &&
    groupData
  ) {
    // Render table if cabins available for category
    return (
      <>
        <EQuoteSailingsFullSearchCabinTable
          key={packageData.id + keyIdentifier + packageData.departure}
          cabins={cabinData}
          superCategory={superCategory}
          superCategoryFullName={superCategoryFullName}
          type={type}
          closeHandler={closeHandler}
          currencySymbol={currencySymbol}
          currencySymbolPlacement={currencySymbolPlacement}
          packageData={packageData}
          groupData={groupData}
        />
      </>
    )
  } else {
    return 'No Cabins for category'
  }
}

const mapStateToProps = (state, ownProps) => {
  const packageDetails = getPackagesDetails(
    state,
    !ownProps.packageData.justACruise,
    ownProps.packageData.identifier
  )

  const cabinData =
    packageDetails.tabularPricing[ownProps.superCategory].pricing

  return {
    cabinData,
    currencySymbol: packageDetails.currencySymbol || '$',
    currencySymbolPlacement: packageDetails.currencySymbolPlacement || 'start',
    packageData: packageDetails,
    ssoData: state.ssoData
  }
}

export default connect(mapStateToProps)(EQuoteSailingsFullSearchCabins)
